export default {
    listNormal: () => import('../listcomponents/list-normal.vue'),
    listRadio: () => import('../listcomponents/list-radio.vue'),
    listTime: () => import('../listcomponents/list-time.vue'),
    listThumbs: () => import('../listcomponents/list-thumbs.vue')
}
